// dependencies
import { Map, fromJS } from "immutable";

import { SetValue as SetCompanyValue } from "../../actions/company.actions";
import { ParseDepartments, ParseGetGroup, ParseGroupSearchResponse } from "../../actions/departments.actions";
import { ParseFeedbackResponse, ParseSingleFeedbackResponse } from "../../actions/feedback.actions";
// actions
import { ParseFields } from "../../actions/fields.actions";
import { ParseHashtags } from "../../actions/hashtags.actions";
import { ParseSelectionObject, UpdateUserSelectionMap } from "../../actions/selection.actions";
import { ParseUserResponse, ParseUserSearchResponse, ParseUsersResponse } from "../../actions/users.actions";

const APIResponseMiddleware = (store) => (next) => (action) => {
	/*
        This will handle server responses.
    */

	const { dispatch } = store;
	const { type } = action;

	if (type.indexOf("@SUCCESS") >= 0) {
		const actionName = type.split("@")[0];

		switch (actionName) {
			case "USERS:SEARCH":
			case "USERS:SEARCH_SELECTION": {
				dispatch(ParseFields(action.data.custom_fields));
				dispatch(ParseDepartments(action.data.departments));
				dispatch(SetCompanyValue("directoryFields", fromJS(action.data.directory_fields)));
				dispatch(UpdateUserSelectionMap(action.userSelectionObjectId, action.data.selected_users));
				dispatch(
					ParseUserSearchResponse(
						action.data.users,
						action.data.counts,
						action.data.display_user_map,
						action.data.page_count,
						action.data.company_billing_admins
					)
				);
				break;
			}

			case "USERS:GETALL":
				dispatch(ParseUsersResponse(action.data));
				break;

			case "USERS:GETONE":
				dispatch(ParseUserResponse(action.data));
				break;

			case "HASHTAGS:GETALL":
				dispatch(ParseHashtags(action.data.hashtags));
				break;

			case "FEEDBACK:GETMANY":
				dispatch(ParseFeedbackResponse(action.data, action.userId, action.view));
				break;

			case "FEEDBACK:GET":
				dispatch(ParseSingleFeedbackResponse(action.data));
				break;

			case "GROUPS:SEARCH":
			case "DEPARTMENTS:SEARCH": {
				const { data, query } = action;
				dispatch(ParseGroupSearchResponse(query, data));
				break;
			}

			case "GROUPS:GET":
			case "DEPARTMENTS:GET": {
				const { data, groupID } = action;
				dispatch(ParseGetGroup(groupID, data));
				break;
			}

			case "SELECTIONS:GET": {
				const { data, selectionId } = action;
				dispatch(ParseSelectionObject(selectionId, data));
				break;
			}

			case "REVIEWS:CYCLE.PROGRESS": {
				const { cycleId, functionName, data } = action;
				let progressValue = "";

				if (["closed", "completed", "active"].indexOf(functionName) >= 0) {
					progressValue = data[functionName];
				} else {
					// progressValue = (data.progress * 100);
					progressValue = Map({
						progress: data.progress * 100,
						count: data.progress_count,
						total: data.total,
					});
				}

				dispatch({
					type: `${actionName}@RESPONSE`,
					progress: progressValue,
					cycleId,
					functionName,
				});
				break;
			}

			case "REVIEWS:CYCLE.GET": {
				const { cycleId, data } = action;
				dispatch({ type: `${actionName}@RESPONSE`, data, cycleId });
				break;
			}

			case "REVIEWS:CYCLE.FILTER": {
				const { cycleId, data, response } = action;
				const isCycleBuilding = response.statusCode === 202;
				dispatch({
					type: `${actionName}@RESPONSE`,
					reviews: isCycleBuilding ? [] : data.reviews,
					reviewsCount: isCycleBuilding ? 0 : data.count,
					cycleId,
				});
				break;
			}

			default: {
				break;
			}
		}
	}

	next(action);
};

export default APIResponseMiddleware;
